<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :disablePage='disablePage'
      :count='count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label >销售单号:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.orderNo"></lk-input>
          </div>
          <div class="queryItem">
            <label >创建日期:</label>
            <timeStampDatePicker type='daterange' placeholder='请选择' class="item" v-model="query.duration"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label >签收日期:</label>
            <timeStampDatePicker type='daterange' placeholder='请选择' class="item" v-model="query.durationReceive"></timeStampDatePicker>
          </div>
          <div class="queryItem" v-if="this.$store.state.user.roleType !== 2" >
            <label >门店:</label>
            <storeListSelect class="item" v-model="query.storeIds"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>订单类型:</label>
            <lk-select v-model='query.type' class="item" clearable  >
              <lk-option v-for="(item, index) in sharedData.orderType" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>订单状态:</label>
            <lk-select v-model='query.status' class="item" clearable  >
              <lk-option v-for="(item, index) in sharedData.orderStatus" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>收款状态:</label>
            <lk-select v-model='query.proceedsStatus' class="item" clearable  >
              <lk-option v-for="(item, index) in sharedData.proceedsStatus" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>物流状态:</label>
            <lk-select v-model='query.receiveds' class="item" clearable :multiple='true'>
              <lk-option v-for="(item, index) in sharedData.expressStatus" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>患者姓名:</label>
            <lk-input placeholder='请输入' v-model="query.patientName" class="item" clearable type="text"></lk-input>
          </div>
          <div class="queryItem">
            <label>订单来源:</label>
            <lk-select v-model='query.orderSourceType' class="item" clearable>
              <lk-option v-for="(item, index) in sourceTypeList" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label >线下预约单号:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.externalOrderNo"></lk-input>
          </div>
          <div class="queryItem">
            <label>签收单:</label>
            <lk-select v-model='query.receiptStatus' class="item" clearable  >
              <lk-option v-for="(item, index) in publicParams.receipt" :key="index" :value='item.value'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>联系人:</label>
            <Contact class="item" v-model="query.contact" :ifAble="true" @contactValue="contactValue"></Contact>
          </div>
          <div class="queryItem">
            <label>联系人电话:</label>
            <lk-input placeholder='请输入' v-model="query.contactPhone" class="item" clearable type="text" :maxlength="20"></lk-input>
          </div>
          <div class="queryItem">
            <label>零售分类:</label>
            <lk-select placeholder='请选择' class="item" v-model.trim='query.retailType' clearable>
              <lk-option v-for="(item, index) in publicParams.retailTypes" :key="index" :value='item.value'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>商品来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable  >
              <lk-option v-for="(item, index) in publicParams.goodsOrigin" :key="index" :value='item.value'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>应收订单:</label>
            <lk-select v-model='query.receivableOrder' class="item" clearable>
              <lk-option value="1">是</lk-option>
              <lk-option value="2">否</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>

      </div>
      <div slot="table">
        <div class="btns">
          <lk-button class="mr8" type='primary' @click="setPageModal=true">设置纸张</lk-button>
          <DownloadButton class="mr8" @on-click="download" v-if="handlePermission('saleOrderDownload')"></DownloadButton>
          <lk-button type='primary' :disabled="!selection || selection.length === 0" @click="batchPrint" v-if="handlePermission('printOrderList')">批量打印</lk-button>
        </div>
        <lk-table border :columns='columns' :data='tableData' @on-selection-change='handleSeletion'/>
      </div>
    </QueryFrame>
    <paymentModal
      v-model="showPayment"
      :orderInfo='orderInfo'
      :receiveVerificationAmount='orderInfo.receiveVerificationAmount'
      :paidList='paidList'
      :update='update'
      :base='saleData'
      :saleOrderDetailList="saleOrderDetailList"
      @submitPay='handlePayment'
      :isCheckOrder='true'
    ></paymentModal>
    <lk-modal v-model="inputReason" title="取消原因" >
      <div class="modalTextarea">
        <lk-input type='textarea'  :maxlength='50' v-model="cancelReason"  :rows='5' :resize='false' placeholder='输入取消原因'></lk-input>
      </div>
      <div slot="footer">
        <lk-button @click="inputReason=false">取消</lk-button>
        <lk-button type='primary' @click="cancelOrder">确定</lk-button>
      </div>
    </lk-modal>
    <lk-modal
      v-model="setPageModal"
      title="设置纸张"
      width='550'
      @on-visible-change='handlePageReset'
    >
      <div class="modelContent">
        <div class="params">
          <lk-form
            :label-width='75'
            label-position="right"
          >
            <lk-row :gutter='16'>
              <lk-col span='8'>
                <lk-form-item label='纸张类型:'>
                  <lk-radio-group v-model="billSize">
                    <lk-radio :label="1">热敏小票</lk-radio>
                    <lk-radio :label="2">二联纸样式1</lk-radio>
                    <lk-radio :label="4">二联纸样式2</lk-radio>
                    <lk-radio :label="3">药品交接确认单（A4）</lk-radio>
                  </lk-radio-group>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <div style="text-align: center;">
              <img width="450" src="../../assets/paperSize.png" alt="">
            </div>
          </lk-form>
        </div>
      </div>
      <div slot="footer">
        <lk-button @click="setPageModal = false">取消</lk-button>
        <lk-button @click="confirmPrintSetting" type='primary'>确定</lk-button>
      </div>
    </lk-modal>
    <ConfirmModal
      :receivedModal.sync='receivedModal'
      :ifShunfeng='ifShunfeng'
      :receiptModal.sync='receiptModal'
      :receiptConfirmModal.sync='receiptConfirmModal'
      :saleExpressReceipt='saleExpressReceipt'
      :expressBrother='expressBrother'
      :saleOrderId="propSaleOrderId"
      :imageList="saleImageList"
      @upSuccess='handlerUpSuccess'
    ></ConfirmModal>
    <lk-modal
      v-model="SFCancelOrderModal.isShow"
      title="取消订单"
      :footer-hide="true"
    >
      <div>
        <div style="font-weight:bold;font-size:14px;">取消原因：</div>
        <div>
          <lk-input v-model="SFCancelOrderModal.reason" type='textarea' :rows="4" placeholder="请输入取消原因"></lk-input>
        </div>
        <div>
          该订单为顺丰医药配送，请确认是否取消运单
        </div>
        <div>
          <lk-switch v-model="SFCancelOrderModal.isCancelOrder" size="small"></lk-switch>
          {{`同时取消运单(单号${SFCancelOrderModal.tempOrderCode})`}}
        </div>
        <div class="btnArea">
          <lk-button type="primary" style="margin-right:16px;" @click="toCancelSfOrder" :loading="confirmOrderLoading">确定</lk-button>
          <lk-button @click="SFCancelOrderModal.isShow=false">取消</lk-button>
        </div>
      </div>
    </lk-modal>
    <printBill ref="printBill" :data='sheetData' :type='billSize' :ifShowDosageform="ifShowDosageform"></printBill>
    <LinkQR027 ref="LinkQR027" :orderInfo='sheetData'></LinkQR027>
    <LinkQR036 ref="LinkQR036" :printData='batchPrintData'></LinkQR036>
    <printBillStyleTwo ref="printBillStyleTwo"></printBillStyleTwo>
    <batchPrintBill ref="batchPrintBill" :printData='batchPrintData' :type='billSize' :ifShowDosageform="ifShowDosageform"></batchPrintBill>
    <batchPrintBillStyleTwo ref="batchPrintBillStyleTwo" :printData='batchPrintData'></batchPrintBillStyleTwo>
    <BarcodeModal
      v-if="barcodeData.orderNo"
      v-model='showBarcode'
      :barcodeData='barcodeData'
      @success='handleSearch'
      ref="barcodeModal"
    ></BarcodeModal>
    <POSModal
      v-model="showDTPModal"
      :content="POSModalContent"
      content_title="未完成浦发POS收款的订单数超限,无法新建订单"
      @handleCancel='showDTPModal=false'
      type="alert"
      :noCancel='true'
      :showCountDown='false'
      @confirm='showDTPModal=false'
      confirmText='知道了'
    ></POSModal>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import sale from '../../services/sale';
import system from '../../services/system';
import insurance from '../../services/insurance';
import printBill from '../../components/sale/printBill.vue';
import printBillStyleTwo from '../../components/sale/printBillStyleTwo.vue';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import PaymentModal from '../../components/sale/PaymentModal.vue';
import DownloadButton from '../../components/download/DownloadButton';
import LinkQR027 from '../../components/print/LinkQR027.vue';
import LinkQR036 from '../../components/print/LinkQR036.vue';
import ConfirmModal from '../../components/sale/confirmModal';
import sharedData from '../../libs/sharedDara';
import Contact from '../../components/sale/Contact';
import BarcodeModal from '../../components/BarcodeModal';
import POSModal from '../../components/POSModal.vue';
import batchPrintBill from '../../components/sale/batchPrintBill.vue';
import batchPrintBillStyleTwo from '../../components/sale/batchPrintBillStyleTwo.vue';

export default {
  name: 'queryOrder',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    printBill,
    PaymentModal,
    DownloadButton,
    LinkQR027,
    LinkQR036,
    ConfirmModal,
    printBillStyleTwo,
    Contact,
    BarcodeModal,
    POSModal,
    batchPrintBill,
    batchPrintBillStyleTwo,
  },
  computed: {
    ownRouter() {
      return this.$store.state.app.permissionList;
    },
    baseInfo() {
      return this.$store.state;
    },
    ifShowDosageform() {
      return this.$store.state.storeInfo.id === 55; // 55赣州门店的id，门店的特殊需求要在规格后加上剂型字段
    },
    patientName() {
      if (this.sheetData.salePrescription && this.sheetData.salePrescription.patientName) {
        return this.sheetData.salePrescription.patientName || '';
      }
      return '';
    },
  },
  watch: {
    showPayment() {
      this.payData.type = 0;
      this.$nextTick(() => {
        this.payData.type = 1;
      });
    },
  },
  data() {
    return {
      saleImageList: [{ imageUrl: '' }],
      sourceTypeList: [], // 来源类型
      POSModalContent: '', // POSModal组件展示内容
      showDTPModal: false, // POSModal组件是否显示
      completePOSCollection: false, // 是否完成pos收款
      showBarcode: false,
      barcodeData: {},
      confirmOrderLoading: false,
      propSaleOrderId: null,
      SFCancelOrderModal: {
        isShow: false,
        reason: '',
        isCancelOrder: false,
        tempOrderCode: '',
      },
      sharedData: {},
      ifShunfeng: false,
      expressBrother: {
        exName: '',
        exPhone: '',
        exDate: '',
        acceptTime: '',
      },
      confirmReceivedLoading: false,
      saleExpressReceipt: {
        imgUrl: '',
        expressId: '',
      },
      receivedModal: false,
      receiptModal: false, // 是否是上传签收单
      receiptConfirmModal: false, // 是否是确认签收单
      saleData: {},
      billSize: 1,
      setPageModal: false,
      orderInfo: {},
      selection: [],
      payLoading: false,
      update: false,
      Received: 0,
      totalReceive: 0,
      paymentList: [],
      sheetData: {
        title: {
          name: '',
          date: '',
          no: '',
        },
        saleOrderProceedsList: [],
        saleOrder: {},
        goodsList: [

        ],
        payData: {

        },
        infos: {
          userName: '',
          storeName: '',
          address: '',
          phone: '',
        },
        salePrescription: {},
      },
      batchPrintData: [],
      disablePage: false,
      payment: 0,
      showPayment: false,
      paymentParams: {

      },
      query: {
        orderNo: '',
        duration: [], // 创建时间
        durationReceive: [], // 签收时间
        type: null, // 订单类型
        receiveds: null, // 物流状态
        proceedsStatus: null, // 收款状态
        status: null, // 订单状态
        storeIds: [],
        purchaseType: 1,
        contact: '',
        receiptStatus: null,
        patientName: '',
        receivableOrder: null,
      },
      params: {
        orderNo: '',
        startTime: null,
        endTime: null,
        receiptStartTime: null,
        receiptEndTime: null,
        storeIds: [],
        receiptStatus: null,
      },
      columns: [
        {
          title: '选择',
          type: 'selection',
          minWidth: 58,
          fixed: 'left',
        },
        { title: '门店名称', key: 'storeName', minWidth: 160 },
        { title: '销售订单号', key: 'orderNo', minWidth: 125 },
        { title: '订单类型', key: 'orderTypeString', minWidth: 90 },
        { title: '订单状态', key: 'statusName', minWidth: 90 },
        {
          title: '收款状态',
          key: 'proceedsStatusStr',
          minWidth: 90,
        },
        { title: '物流状态', key: 'receivedStatusName', minWidth: 90 },
        {
          title: '创建时间', key: 'createTime', minWidth: 100,
        },
        {
          title: '收款完成时间', key: 'payTime', minWidth: 105,
        },
        {
          title: '签收时间', key: 'confirmReceiptTime', minWidth: 100,
        },
        { title: '患者姓名', key: 'prescriptionPatientName', minWidth: 90 },
        { title: '订单金额', key: 'totalAmountDisplay', minWidth: 100 },
        { title: '折扣金额', key: 'discount', minWidth: 100 },
        { title: '应收金额', key: 'amountWithoutDiscount', minWidth: 100 },
        { title: '实收金额', key: 'realProceedsAmount', minWidth: 100 },
        {
          title: '收款方式',
          key: 'proceedsAmountString',
          minWidth: 183,
          render: (h, params) => this.renderTooTip(h, 2, params.row.proceedsAmountString),
        },
        {
          title: '核销关系',
          key: 'depositString',
          minWidth: 183,
          render: (h, params) => this.renderTooTip(h, 2, params.row.depositString),
        },
        { title: '订单来源', key: 'epSourceTypeName', minWidth: 100 },
        {
          title: '线下预约单号', key: 'externalOrderNo', minWidth: 130, tooltip: true,
        },
        {
          title: '运费',
          key: 'freight',
          minWidth: 116,
          render: (h, params) => h('span', params.row.freight || ''),
        },
        {
          title: '签收单',
          minWidth: 90,
          render: (h, params) => h('span', params.row.receiptStatus ? this.publicParams.receipt[params.row.receiptStatus - 1].name : ''),
        },
        { title: '应收订单', key: 'receivableOrder', minWidth: 90 },
        { title: '零售分类', key: 'goodsTypeName', minWidth: 90 },
        { title: '商品来源', key: 'purchaseTypeName', minWidth: 90 },
        { title: '联系人', key: 'contact', minWidth: 90 },
        { title: '联系人电话', key: 'contactPhone', minWidth: 120 },
        { title: '营业员', key: 'createUserName', minWidth: 90 },
        {
          title: '操作',
          width: 200,
          fixed: 'right',
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.sheetData.title.name = params.row.storeName;
                  this.sheetData.title.date = params.row.createTime;
                  this.sheetData.title.no = params.row.orderNo;
                  this.sheetData.infos.userName = params.row.createUserName;
                  // this.sheetData.payData.totalAmount = params.row.totalAmount;
                  this.sheetData.proceedsList = [];
                  sale.getOrderAllById({ id: params.row.id }).then((res) => {
                    if (res.data.status === 200) { // 有时间需要重构
                      // console.log(res.data.data);
                      const temp = res.data.data;
                      // this.sheetData=utils.deepClone(temp);
                      this.sheetData.saleOrderDetailList = temp.saleOrderDetailList;
                      this.sheetData.insurance = temp.insurance;
                      this.sheetData.saleOrderDetailList.forEach((item1) => {
                        const obj = temp.saleOrderDetailVoList.find(item2 => item1.goodsStoreId === item2.goodsStoreId);
                        item1.storageCondition = (obj && obj.storageCondition) || '';
                      });
                      this.sheetData.orderTaxFreeAmountDisplay = temp.orderTaxFreeAmountDisplay;
                      this.sheetData.realCashProceeds = temp.realCashProceeds;
                      this.sheetData.salePrescription = temp.salePrescription;

                      this.sheetData.changeAmount = utils.fixNumber(temp.proceedsAmount - temp.realProceedsAmount, 2);
                      // this.saleData = res.data.data;

                      this.sheetData.goodsList = [];


                      temp.saleOrderDetailVoList.forEach((item) => {
                        const {
                          goodsStoreId, goodsLot, unpackMinPkgUnit, realPrice,
                        } = item.saleOrderDetail;
                        item.feMixKey = goodsStoreId + goodsLot + unpackMinPkgUnit + realPrice;
                        let exist = false;
                        console.log(item);
                        this.sheetData.goodsList.forEach((el) => {
                          if (item.feMixKey === el.feMixKey) {
                            el.saleOrderDetail.goodsCount += item.saleOrderDetail.goodsCount;
                            el.saleOrderDetail.amount += item.saleOrderDetail.amount;
                            el.saleOrderDetail.amountDisplay += item.saleOrderDetail.amountDisplay;
                            exist = true;
                          }
                        });
                        exist || this.sheetData.goodsList.push(item);
                      });
                      // if (temp.saleOrderDetailList && temp.saleOrderDetailList.length) {
                      //   this.sheetData.goodsList = temp.saleOrderDetailVoList;
                      // }
                      temp.saleOrderProceedsList.forEach((el) => {
                        if (el.amount) {
                          // el.amount = utils.exchangePercent(el.amount);

                          this.sheetData.proceedsList.push(el);
                        }
                      });
                      this.sheetData.saleOrder = temp.saleOrder;
                      this.sheetData.salePrescription = temp.salePrescription;
                      this.sheetData.saleExpress = temp.saleExpress;
                      this.sheetData.infos.storeName = temp.saleOrder.storeName;
                      this.sheetData.retailType = temp.retailType;
                      this.sheetData.financeInvoiceVoList = temp.financeInvoiceVoList;
                      this.sheetData.cutPrice = temp.cutPrice;

                      this.sheetData.realProceedsAmount = temp.realProceedsAmount;
                      this.sheetData.amountToProceeds = temp.amountToProceeds;
                      if (this.billSize === 3) {
                        this.$refs.LinkQR027.print();
                      } else if (this.billSize === 4) {
                        this.$refs.printBillStyleTwo.tableData = this.sheetData.saleOrderDetailList;
                        this.$refs.printBillStyleTwo.patientName = this.patientName;
                        this.$nextTick(() => {
                          this.$refs.printBillStyleTwo.handlePrint();
                        });
                      } else {
                        this.$refs.printBill.print();
                      }
                    } else {
                      this.$Message.error(res.data.error);
                    }
                  }).catch((err) => {
                    utils.handleError(err);
                  });
                },
              },
            }, '打印'),
            [2, 5].includes(params.row.status) || this.handlePermission('salesOrderCheck') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'salesOrderCheck', params: { id: params.row.id, taskId: params.row.taskId } });
                },
              },
            }, '查看') : null,

            this.handlePermission('coldChainInfoEdit') && params.row.editable === 1 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                // disabled: params.row.editable !== 1,
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'coldChainInfoEdit', params: { id: params.row.id } });
                },
              },
            }, '冷链') : null,
            this.handlePermission('salesOrderCancel') && params.row.status === 1 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: !params.row.ableToCancel,
              },
              on: {
                click: () => {
                  this.tempId = params.row.id;
                  if (params.row.saleExpress && params.row.saleExpress.deliveryMethod === 2) {
                    this.SFCancelOrderModal.isShow = true;
                    this.SFCancelOrderModal.tempOrderCode = params.row.saleExpress.code || '';
                  } else {
                    this.inputReason = true;
                  }
                },
              },
            }, '取消订单') : null,
            this.handlePermission('insuranceRefund') && params.row.insuranceRefund === 1 ? h('lk-button', {// 西安医保退费后续
              props: {
                type: 'text',
                size: 'small',
                // disabled: params.row.status !== 1,
              },
              on: {
                click: () => {
                  const data = params.row.insurance;
                  console.log(data);

                  const formated = {
                    currentUid: this.user.info.id,
                    orderId: data.orderId,
                    AKC190: data.medicalCode,
                    AKA130: data.medicalType,
                    AAC001: data.userCode,
                  };
                  insurance.insuranceRefund(formated).then((res) => {
                    if (res.data.status === 200) {
                      this.$Message.success('退费成功');
                    } else {
                      this.$Message.error(res.data.error);
                    }
                  }).catch((err) => {
                    utils.handleError(err);
                  });
                },
              },
            }, '医保退费') : null,
            this.handlePermission('salesOrderPay') && params.row.ableToProceeds ? h('lk-button', {
              props: {
                type: 'text',
                disabled:
                  (params.row.deliveryMethod === 2 && !params.row.tag === 1)
                  || params.row.doOverCollection === 1
                  // 配送订单pos收款后也置灰
                  || (params.row.type === 2 && [2, 5].includes(params.row.status)),
                size: 'small',
              },
              on: {
                click: async () => {
                  if (params.row.tag === 2 && params.row.proceedsStatus !== 1) {
                    const {
                      orderNo,
                      id,
                    } = params.row;
                    this.barcodeData = {
                      orderNo,
                      id,
                    };
                  }
                  if (params.row.status === 1) {
                    this.update = false;
                  } else {
                    this.totalReceive = params.row.totalAmount;
                    this.update = true;
                  }

                  this.payData = {
      	            id: '', // 订单ID,
                    type: params.row.type || 0,

                  };
                  this.payData.id = params.row.id;
                  this.paidList = params.row.saleOrderProceedsList;
                  // this.paidList.find(item=> item.)

                  const detail = await this.getOrderDetails(params.row.id);
                  if (detail && detail.saleOrderDetailList) {
                    this.saleOrderDetailList = detail.saleOrderDetailList;
                  }
                  if (detail && detail.depositFinanceDepositList) {
                    this.paidList.forEach((item) => {
                      if (item.proceedsTypeName === '预收款') {
                        item.financeDepositId = detail.depositFinanceDepositList[0].id;
                        item.financeDeposit = detail.depositFinanceDepositList[0];
                      }
                    });
                  }
                  this.saleData = params.row;
                  this.completePOSCollection = params.row.tag === 2 && params.row.proceedsStatus === 1;
                  this.orderInfo = {
                    payment: params.row.amountWithoutDiscount !== null ? params.row.amountWithoutDiscount : params.row.totalAmount,
                    totalAmount: params.row.totalAmount,
                    discount: params.row.discount || 0,
                    goodsCount: params.row.totalGoodsNum,
                    saleExpress: params.row.saleExpress,
                    notOrigin: params.row.notOrigin,
                    type: params.row.orderType * 1,
                    sourceType: params.row.epSourceType || 0,
                    insuranceId: params.row.insuranceId * 1,
                    status: params.row.status * 1,
                    switchStatus: detail.saleOrder.showPatientFlag,
                    patientName: detail.saleOrder.relatePatientName || '',
                    patientPhone: detail.saleOrder.originalPatientPhone || '',
                    receiveVerificationAmount: detail.saleOrder.receiveVerificationAmount,
                    receiveFinanceDepositList: detail.receiveFinanceDepositList,
                    promoteDiscountVOList: detail.promoteDiscountVOList || [], // 折扣信息
                    isCollection: params.row.tag === 1 || '',
                    receiveAmountList: detail.depositFinanceDepositList || [],
                    completePOSCollection: params.row.tag === 2 && params.row.proceedsStatus === 1, // 是否完成pos收款
                    tag: params.row.tag || '',
                    receivablesAmount: params.row.receivablesAmount || 0, // 如果完成pos收款此值就代表pos收款金额
                    hideTopInfo: true,
                  };
                  this.showPayment = true;
                },
              },
              // 顺丰代收改名字确认收款
            }, params.row.tag === 1
              ? '确认收款'
              : '收款') : null,
            params.row.received === 1 && params.row.status === 1 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  if (params.row.saleExpress && params.row.saleExpress.deliveryMethod === 2) {
                    if (params.row.proceedsStatus !== 1) {
                      this.$Message.error('SF配送订单需完成收款后才可以确认收货');
                      return;
                    }
                  }
                  if (params.row.proceedsStatus !== 1) {
                    this.$Message.error('配送订单需完成收款后才可以确认收货');
                    return;
                  }
                  this.propSaleOrderId = params.row.id;
                  this.ifShunfeng = params.row.epSourceType === 9;
                  this.saleExpressReceipt.expressId = params.row.expressId;
                  this.saleExpressReceipt.imgUrl = '';
                  this.saleImageList = [{ imageUrl: '' }];
                  this.expressBrother.code = params.row.code || ''; // 物流单号
                  this.expressBrother.acceptTime = params.row.acceptTime ? this.transferDate(params.row.acceptTime) : ''; // 签收时间
                  this.receivedModal = true;
                },
              },
            }, '确认收货') : null,
            params.row.received === 2 && params.row.receiptStatus === 1 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.saleExpressReceipt.expressId = params.row.expressId;
                  this.saleExpressReceipt.imgUrl = params.row.SFImage || '';
                  this.saleImageList = [];
                  if (params.row.SFImages.length > 0) {
                    params.row.SFImages.forEach((element) => {
                      this.saleImageList.push({ imageUrl: element });
                    });
                  } else {
                    this.saleImageList = [{ imageUrl: '' }];
                  }
                  this.expressBrother.exName = params.row.exName || '';
                  this.expressBrother.exPhone = params.row.exPhone || '';
                  this.expressBrother.exDate = this.transferDate(params.row.exDate);
                  this.receivedModal = true;
                  this.receiptModal = true;
                },
              },
            }, '上传签收单') : null,
            params.row.received === 2 && params.row.receiptStatus === 2 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.saleExpressReceipt.expressId = params.row.expressId;
                  this.saleExpressReceipt.imgUrl = params.row.SFImage || '';
                  this.saleImageList = [];
                  if (params.row.SFImages.length > 0) {
                    params.row.SFImages.forEach((element) => {
                      this.saleImageList.push({ imageUrl: element });
                    });
                  } else {
                    this.saleImageList = [{ imageUrl: '' }];
                  }
                  this.expressBrother.exName = params.row.exName || '';
                  this.expressBrother.exPhone = params.row.exPhone || '';
                  this.expressBrother.exDate = this.transferDate(params.row.exDate);
                  this.receivedModal = true;
                  this.receiptConfirmModal = true;
                },
              },
            }, '确认签收单') : null,
            // rightFlag为2时展示药学服务按钮
            this.handlePermission('pharmaceuticalCare') && params.row.rightFlag && params.row.rightFlag === 2 && h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'pharmaceuticalCare', params: { id: params.row.id, taskId: params.row.taskId ? params.row.taskId : null } });
                },
              },
            }, '药学服务'),
            // 单号二维码
            ![3, 4].includes(params.row.status) && params.row.tag === 2 && params.row.proceedsStatus !== 1 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  const {
                    orderNo,
                    id,
                  } = params.row;
                  this.barcodeData = {
                    orderNo,
                    id,
                  };
                  this.showBarcode = true;
                },
              },
            }, '单号二维码') : null,
          ]),
        },
      ],
      paidList: [],
      inputReason: false,
      cancelReason: '',
      tableData: [],
      lastPay: {
        paymentMedicare: null, // 医保收款

        paymentCash: null, // 现金收款

        paymentWechat: null, // 微信收款

        paymentAlipay: null, // 支付宝收款

        paymentUnionpay: null, // 银联卡收款

        paymentPrepay: null, // 预收款
      },
      status: ['', '待完成', '已完成', '取消中', '已取消'],
      typeList: ['', '店销', '配送'],
      paymentArr: ['已收款', '部分收款', '未收款'], // 收款状态列表
      storeList: [],
      payData: {
      	id: '', // 订单ID,

      },
      tempId: '',
      saleOrderDetailList: [],
    };
  },
  methods: {
    getListSourceType() {
      return new Promise((resolve) => {
        sale.getListSourceType().then((res) => {
          if (res.data.status === 200) {
            this.sourceTypeList = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    toCancelSfOrder() {
      if (!this.SFCancelOrderModal.reason) {
        this.$Message.error('请输入订单取消原因');
        return;
      }
      const isCancel = this.SFCancelOrderModal.isCancelOrder ? 1 : 2; // 1 取消， 2不取消
      this.confirmOrderLoading = true;
      sale.cancelOrder({ orderId: this.tempId, cancelReason: this.SFCancelOrderModal.reason, cancelSfOrderFlag: isCancel }).then((res) => {
        this.confirmOrderLoading = false;
        if (res.data.status === 200) {
          this.$Message.success('取消成功');
          this.SFCancelOrderModal.isShow = false;
          this.getData();
        } else if (res.data.status === 91012) {
          this.$Modal.confirm({
            title: '取消订单',
            content: `<p>运单取消失败，失败原因：${res.data.error}，是否单独取消销售订单？</p>`,
            okText: '只取消订单',
            cancelText: '放弃',
            onOk: () => {
              sale.cancelOrder({ orderId: this.tempId, cancelReason: this.SFCancelOrderModal.reason, cancelSfOrderFlag: 2 }).then((res) => {
                if (res.data.status === 200) {
                  this.$Message.success('取消成功');
                  this.SFCancelOrderModal.isShow = false;
                  this.getData();
                } else {
                  this.$Message.error(res.data.error);
                }
              }).catch((err) => {
                utils.handleError(err);
              });
            },
          });
        } else {
          this.confirmOrderLoading = false;
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    transferDate(val) {
      const d = new Date(val); // 根据时间戳生成的时间对象
      const year = d.getFullYear();
      let month = d.getMonth() + 1;
      let day = d.getDate();
      let hour = d.getHours();
      let minute = d.getMinutes();
      let second = d.getSeconds();
      if (month < 10) {
        month = `0${month}`;
      }
      if (day < 10) {
        day = `0${day}`;
      }
      if (hour < 10) {
        hour = `0${hour}`;
      }
      if (minute < 10) {
        minute = `0${minute}`;
      }
      if (second < 10) {
        second = `0${second}`;
      }
      const html = `${year}-${month}-${day}  ${hour}:${minute}:${second}`;
      return html;
    },
    confirmReceived() {
      if (this.saleImageList.length <= 0) {
        this.$Message.error('请选择图片');
        return;
      }
      this.confirmReceivedLoading = true;
      sale.confirmReceipt(this.saleExpressReceipt).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('确认收货成功');
          this.handleSearch();
        } else {
          this.$Message.error(res.data.error);
        }
        this.confirmReceivedLoading = false;
        this.receivedModal = false;
      }).catch((err) => {
        this.confirmReceivedLoading = false;
        utils.handleError(err);
      });
    },
    handleReceived() {},
    handlePageReset(isOpen) {
      isOpen || (this.billSize = localStorage.getItem('billSize') * 1 || 1);
    },
    confirmPrintSetting() {
      localStorage.setItem('billSize', `${this.billSize}`);
      this.setPageModal = false;
    },
    handleSeletion(selection) {
      this.selection = selection;
    },
    batchPrint() {
      this.batchPrintData = [];
      const orderIdList = this.selection.map(item => item.id);
      sale.printOrderList({ orderIdList }).then((res) => {
        if (res.data.status === 200) {
          const printList = [];
          res.data.data.forEach((temp) => {
            const sheetData = {
              title: {
                name: '',
                date: '',
                no: '',
              },
              saleOrderProceedsList: [],
              saleOrder: {},
              goodsList: [],
              payData: {},
              infos: {
                userName: '',
                storeName: '',
                address: '',
                phone: '',
              },
              salePrescription: {},
              proceedsList: [],
            };
            const saleOrder = temp.saleOrder;
            sheetData.title.name = saleOrder.storeName;
            sheetData.title.date = saleOrder.createTime;
            sheetData.title.no = saleOrder.orderNo;
            sheetData.infos.userName = saleOrder.createUserName;
            sheetData.saleOrderDetailList = temp.saleOrderDetailList;
            sheetData.saleOrderDetailList.forEach((item1) => {
              const obj = temp.saleOrderDetailVoList.find(item2 => item1.goodsStoreId === item2.goodsStoreId);
              item1.storageCondition = (obj && obj.storageCondition) || '';
            });
            sheetData.orderTaxFreeAmountDisplay = temp.orderTaxFreeAmountDisplay;
            sheetData.realCashProceeds = temp.realCashProceeds;
            sheetData.salePrescription = temp.salePrescription;
            sheetData.changeAmount = utils.fixNumber(temp.proceedsAmount - temp.realProceedsAmount, 2);
            sheetData.goodsList = [];
            temp.saleOrderDetailVoList.forEach((item) => {
              const {
                goodsStoreId, goodsLot, unpackMinPkgUnit, realPrice,
              } = item.saleOrderDetail;
              item.feMixKey = goodsStoreId + goodsLot + unpackMinPkgUnit + realPrice;
              let exist = false;
              sheetData.goodsList.forEach((el) => {
                if (item.feMixKey === el.feMixKey) {
                  el.saleOrderDetail.goodsCount += item.saleOrderDetail.goodsCount;
                  el.saleOrderDetail.amount += item.saleOrderDetail.amount;
                  el.saleOrderDetail.amountDisplay += item.saleOrderDetail.amountDisplay;
                  exist = true;
                }
              });
              exist || sheetData.goodsList.push(item);
            });
            temp.saleOrderProceedsList && temp.saleOrderProceedsList.forEach((el) => {
              if (el.amount) {
                sheetData.proceedsList.push(el);
              }
            });
            sheetData.saleOrder = temp.saleOrder;
            sheetData.salePrescription = temp.salePrescription;
            sheetData.saleExpress = temp.saleExpress;
            sheetData.infos.storeName = temp.saleOrder.storeName;
            sheetData.retailType = temp.retailType;
            sheetData.financeInvoiceVoList = temp.financeInvoiceVoList;
            sheetData.cutPrice = temp.cutPrice;
            sheetData.realProceedsAmount = temp.realProceedsAmount;
            sheetData.amountToProceeds = temp.amountToProceeds;
            printList.push(sheetData);
          });
          this.batchPrintData.push(...printList);
          if (this.billSize === 3) {
            this.$refs.LinkQR036.print();
          } else if (this.billSize === 4) {
            this.$refs.batchPrintBillStyleTwo.print();
          } else {
            this.$refs.batchPrintBill.print();
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleChange() {
      let total = 0;
      this.paymentList.forEach((item) => {
        total += item.amount;
      });
      this.totalReceive = total;
    },
    cancelOrder() {
      if (!this.cancelReason) {
        this.$Message.error('请输入订单取消原因');
        return;
      }
      sale.cancelOrder({ orderId: this.tempId, cancelReason: this.cancelReason }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('取消成功');
          this.inputReason = false;
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        orderNo: '',
        duration: [],
        durationReceive: [], // 签收时间
        type: null, // 订单类型
        receiveds: null, // 物流状态
        proceedsStatus: null, // 收款状态
        status: null, // 订单状态
        storeIds: [],
        contact: '',
        purchaseType: null,
        receiptStatus: null,
        patientName: '',
        receivableOrder: null,
      };
    },
    getStoreList() {
      system.getBelongStores()
        .then((res) => {
          if (res.data.status === 200) {
            this.storeList = res.data.data;
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
    },
    getOrderDetails(id) {
      return new Promise((resolve) => {
        sale.getOrderAllById({
          id,
        }).then((res) => {
          if (res.data.status === 200) {
            resolve(res.data.data);
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    handlerUpSuccess() {
      this.handleSearch();
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.duration && this.params.duration.length) {
        this.params.startTime = this.params.duration[0];
        this.params.endTime = this.params.duration[1];
      }
      if (this.params.durationReceive && this.params.durationReceive.length) {
        this.params.receiptStartTime = this.params.durationReceive[0];
        this.params.receiptEndTime = this.params.durationReceive[1];
      }
      sale
        .listReport(this.params)
        .then((res) => {
          if (res.data.status === 200) {
            this.tableData = [];
            this.count = res.data.data.count;
            res.data.data.list.forEach((item) => {
              const result = {};
              utils.exchangeTable(item.saleOrder, result);
              result.insurance = item.insurance;
              result.taskId = item.taskId || '';
              result.received = item.saleExpress && item.saleExpress.received;
              result.expressId = item.saleExpress && item.saleExpress.id;
              result.SFImage = (item.saleExpress && item.saleExpress.sfimage) || '';
              result.SFImages = (item.saleExpress && item.saleExpress.sfimages) || [];
              result.receivedStatusName = item.saleExpress && item.saleExpress.receivedStatusName;
              result.exName = (item.saleExpress && item.saleExpress.sfcourier) || '';
              result.exPhone = (item.saleExpress && item.saleExpress.sfcourierPhone) || '';
              result.exDate = (item.saleExpress && item.saleExpress.modifiedTime) || '';
              result.insuranceRefund = item.insuranceRefund;
              result.pharmaceuticalStatus = item.pharmaceuticalStatus;
              // result._disabled = !result.ableToCreateProceeds;
              result.createTime = utils.exchangeTimeToSecond(result.createTime);
              result.payTime = result.payTime == null ? '' : utils.exchangeTimeToSecond(result.payTime);
              result.confirmReceiptTime = result.confirmReceiptTime == null ? '' : utils.exchangeTimeToSecond(result.confirmReceiptTime);
              result.orderType = item.orderType;
              result.proceedsStatusStr = this.paymentArr[result.proceedsStatus - 1];
              result.orderTypeString = this.typeList[item.orderType];
              // result.statusName = this.status[result.status];
              result.loading = false;
              result.totalGoodsNum = item.saleOrder.totalGoodsNum;
              result.totalAmount = item.saleOrder.totalAmount;
              result.realProceedsAmount = item.realProceedsAmount;
              result.ableToCancel = item.saleOrder.ableToCancel;
              result.saleExpress = item.saleExpress;
              result.goodsTypeName = utils.exchangePublicParams(result.retailType, this.publicParams.retailTypes);

              result.realCashProceeds = item.realCashProceeds && item.realCashProceeds.amount;
              result.notOrigin = !result.epId;
              result.saleOrderProceedsList = [];
              result.receiptStatus = item.saleExpress && item.saleExpress.receiptStatus;
              result.code = item.saleExpress && item.saleExpress.code;
              result.acceptTime = item.saleExpress && item.saleExpress.acceptTime;
              result.freight = item.saleExpress && item.saleExpress.freight;
              result.rightFlag = item.rightFlag || '';
              if (item.saleOrderProceedsList) {
                result.saleOrderProceedsList = item.saleOrderProceedsList;
                result.saleOrderProceedsList = utils.deepClone(item.saleOrderProceedsList);

                item.saleOrderProceedsList.forEach((el) => {
                  result[`proceedsTypeId${el.proceedsTypeId}`] = el.amount;
                });
              }
              result.prescriptionPatientName = item.prescriptionPatientName || '';
              this.tableData.push(result);
            });
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    handlePayment(paymentList, infos, expressInfo, base, curPatientInfo, promotionInfo, receiveAmountList, specialCollection) {
      let totalReceiveAmount = 0;
      if (receiveAmountList.length) {
        receiveAmountList.forEach((item) => {
          if (item.depositVerificationAmount) {
            totalReceiveAmount += item.depositVerificationAmount * 1;
          }
        });
      }
      const paymentListCopyed = utils.deepClone(paymentList);
      paymentListCopyed.push({
        proceedsTypeId: 6,
        proceedsTypeName: '预收款',
        amount: utils.toFixed2(totalReceiveAmount),
      });
      const tempPay = base || {};
      receiveAmountList.forEach((item) => {
        item.financeDepositId = item.id;
        item.amount = item.depositVerificationAmount;
      });
      tempPay.financeDepositOrderList = receiveAmountList || '';
      tempPay.saleOrder = { id: this.payData.id };
      tempPay.saleOrderProceedsList = utils.deepClone(paymentListCopyed);
      tempPay.saleExpress = expressInfo;
      console.log(expressInfo);
      paymentListCopyed.forEach((item) => {
        if (item.financeDepositId && item.amount) {
          tempPay.financeDepositId = item.financeDepositId;
          tempPay.verificationDeposit = item.amount;
        }
      });
      this.payLoading = true;
      const promoteDiscountVOList = utils.deepClone(promotionInfo.promoteDiscountVOList);
      if (promotionInfo.promotionDiscount) {
        const { promotionDiscount, promotionReason } = promotionInfo;
        const promotionItem = {
          cutPrice: promotionDiscount,
          remark: promotionReason,
        };
        promoteDiscountVOList.push(promotionItem);
      }
      // 如果有pos收款，入参增加tag=2；
      if (specialCollection && specialCollection.SPDBAmountList.amount) {
        tempPay.saleOrder.tag = 2;
        tempPay.saleOrder.receivablesAmount = specialCollection.SPDBAmountList.amount;
      }
      const {
        totalAmount,
        discount,
      } = base;
      tempPay.saleOrder.totalAmount = totalAmount;
      tempPay.saleOrder.discount = discount;

      tempPay.discount = infos.discount;
      tempPay.promoteDiscountVOList = promoteDiscountVOList;

      sale.payOrder(tempPay).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('收款成功！');
          this.showPayment = false;
          // pos收款有值，并且未完成pos收款的时候
          if (specialCollection.SPDBAmountList.amount && !this.completePOSCollection) {
            this.showBarcode = true;
          }
        } else if (res.data.status === 80000) {
          this.showDTPModal = true;
          this.POSModalContent = res.data.error;
          this.showPayment = false;
        } else {
          this.$Message.error(res.data.error);
        }
        this.payLoading = false;
        this.handleSearch();
      }).catch((err) => {
        this.handleSearch();
        this.payLoading = false;
        utils.handleError(err);
      });
    },

    download() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;
      if (params.duration && params.duration.length) {
        params.startTime = params.duration[0];
        params.endTime = params.duration[1];
      }
      if (params.durationReceive && params.durationReceive.length) {
        params.receiptStartTime = params.durationReceive[0];
        params.receiptEndTime = params.durationReceive[1];
      }
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      // params.startTime = utils.exchangeDate(params.startTime);
      // params.endTime = utils.exchangeDate(params.endTime);
      sale.downloadReport(params).then((res) => {
        console.log(res);

        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPaymentList() {
      return new Promise((resolve) => {
        system.getStoreProceedsTypeList().then((res) => {
          if (res.data.status === 200) {
            this.paymentList = res.data.data.list;
            this.paymentList.forEach((item) => {
              item.amount = null;
            });
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    contactValue(val) {
      this.query.contactPhone = val;
    },

    /**
    * renderTooTip 表格超出提示
    * @param {*} h
    * @param {*} lines 最大显示行数
    * @param {*} content 行内容
    */
    renderTooTip(h, lines, content) {
      return h('lk-tooltip', {
        props: { placement: 'bottom', transfer: true },
      }, [
        h('span',
          {
            style: {
              textOverflow: 'ellipsis', whiteSpace: 'normal', overflow: 'hidden', display: '-webkit-box', webkitBoxOrient: 'vertical', webkitLineClamp: `${lines}`,
            },
          }, content),
        h('span', { slot: 'content', style: { whiteSpace: 'normal', wordBreak: 'break-all' } }, content),
      ]);
    },
  },
  created() {
    this.sharedData = sharedData;
  },
  mounted() {
    if (this.$store.state.user.roleType === 2) {
      for (let i = 0; i < this.columns.length; i += 1) {
        if (this.columns[i].key === 'storeName') {
          this.columns.splice(i, 1);
          i -= 1;
        }
      }
    }
    this.getListSourceType().then(() => {
      this.getPaymentList().then(() => {
        this.handleSearch(true);
      });
    });
    this.billSize = localStorage.getItem('billSize') * 1 || 1;
  },
};
</script>
<style lang="less" scoped>

/deep/ .ivu-table-wrapper {
  .ivu-table {
    line-height: 15px !important;
    th {
      height: auto;
      padding: 10px 0;
    }
    td {
      padding: 5px 0;
      height: auto;
    }
    .ivu-table-cell {
      .ivu-btn {
        line-height: 0.6;
      }
    }
    .ivu-table-tip table td {
      height: 40px;
    }
  }
}

  .btns{
    margin-bottom: 12px
  }
  .totalPay{
    font-size: 16px;
    color: #1890FF;
  }

  .saleBill {
    // width: 143vw;
  }
  .warnInfo {
    color: red;
    margin-left: 90px;
  }
  .btnArea {
    display: flex;
    justify-content: flex-end;
  }
</style>
